import { PureComponent, type ReactNode } from "react";

import { LoadingSpinner } from "widgets";

import GenericDataTableContainer from "../core/grid/GenericDataTableContainer.js";
import { ChildEntitiesButtonHeader } from "../core/navigation-panel/ButtonHeaderHoc.js";
import { VariantMutantGenomesSelectionWidget } from "../genome-viewer/VariantMutantGenomesSelectionForm.js";
import RefGenomeSelector from "./RefGenomeSelector.js";
import { type InputTableQuerySpec, type Maybe, type Organism, type VariantAnalysisGroup } from "@/graphql.ts";
import { ENTITY_TYPE } from "@/settings/settings.js";

export interface IGenericVariantsViewProps {
  //tableTitle: string;
  tableSpec?: InputTableQuerySpec;
  variantAnalysisGroup?: VariantAnalysisGroup;
  viewId?: number;
  hideAnalyzeBtn?: boolean;
  hideVariantGenomesBtn?: boolean;

  getSummaryEntityName: () => string; // for classic portal mapping

  title?: string;
  subtitle?: string;
  headerAttributes?: JSX.Element[];
}

class GenericVariantsView extends PureComponent<IGenericVariantsViewProps> {
  constructor(props: IGenericVariantsViewProps) {
    super(props);
  }

  getSelectorWidget = (): ReactNode => {
    if (this.props.tableSpec?.resultType === ENTITY_TYPE.VARIANT) {
      // complains anyway disregard the type because Maybe..
      const referenceGenomes: Maybe<Organism>[] | undefined | null = this.props.variantAnalysisGroup?.refGenomes;
      return (
        referenceGenomes &&
        !!referenceGenomes.length && (
          <RefGenomeSelector referenceGenomes={referenceGenomes as Organism[]} preferredRefGenomeId={undefined} />
        )
      );
    }
    if (this.props.tableSpec?.resultType === ENTITY_TYPE.VCF_VARIANT) {
      return (
        <VariantMutantGenomesSelectionWidget
          variantAnalysisGroup={this.props.variantAnalysisGroup}
          tableQuerySpec={this.props.tableSpec}
        />
      );
    }
    return null;
  };

  render() {
    return (
      <>
        {!this.props.tableSpec ? (
          <LoadingSpinner />
        ) : (
          <GenericDataTableContainer
            title={this.props.title}
            subtitle={this.props.subtitle}
            headerAttributes={this.props.headerAttributes}
            tableSpec={this.props.tableSpec}
            middleToolbarElement={this.props.tableSpec && this.getSelectorWidget()}
            rightToolbarElement={
              <ChildEntitiesButtonHeader
                tableSpec={this.props.tableSpec}
                getParentEntityName={this.props.getSummaryEntityName}
                hideAnalyzeBtn={this.props.hideAnalyzeBtn}
                hideVariantGenomesBtn={this.props.hideVariantGenomesBtn}
              />
            }
            viewId={this.props.viewId}
          />
        )}
      </>
    );
  }
}

export default GenericVariantsView;
